import {
    Button,
    Typography,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@mui/material';
import { sendJsonData } from '../../../helpers/sendJsonData';
import { ERROR_MESSAGES, SUCCESS_MESSAGES } from '../../../configs/messages';
import showMessage from '../../../helpers/showMessage';
import React, { useEffect, useState } from 'react';
import { ROUTES_LIST } from '../../../helpers/routesList';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { LOCAL_STORAGE_USER } from '../../../configs/constants';
import {
    LocalizationProvider,
    DesktopDatePicker,
    DateTimePicker,
} from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import locale from 'date-fns/locale/en-US';
import RemoveIcon from '@mui/icons-material/Remove';
import { differenceInCalendarDays } from 'date-fns';
import { format } from 'date-fns/esm';
import PageHeader from '../includes/PageHeader';

export function Execute() {
    const [errors, setErrors] = useState({});
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();

    const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
    const token = user.accessToken;
    const [datepickerIsDisabled, setDatepickerIsDisabled] = useState(false);

    const [showSaveButton, setShowSaveButton] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [scheduledTime, setScheduledTime] = useState(null);

    const [initialData, setInitialData] = useState({
        startDate: null,
        endDate: null,
    });

    useEffect(() => {
        if (initialData.startDate && initialData.endDate) {
            const tempErrors = validate();

            for (const key in tempErrors) {
                if (tempErrors[key]) {
                    showMessage(
                        ERROR_MESSAGES.FILL_THE_FORM,
                        enqueueSnackbar,
                        'error',
                    );
                    return;
                }
            }

            setShowSaveButton(true);
            setDatepickerIsDisabled(true);
        }
    }, [initialData.startDate, initialData.endDate]);

    const validate = () => {
        let tempErrors = { ...errors };
        const requiredMessage = ERROR_MESSAGES.FILL_THE_FIELD;

        if ('startDate' in initialData && 'endDate' in initialData) {
            tempErrors.endDate = initialData.endDate ? '' : requiredMessage;
            tempErrors.startDate = initialData.startDate ? '' : requiredMessage;

            let diff = differenceInCalendarDays(
                new Date(initialData.endDate),
                new Date(initialData.startDate),
            );

            if (diff !== 6) {
                tempErrors.endDate = 'error';
                tempErrors.startDate = 'error';
                showMessage(
                    ERROR_MESSAGES.NOT_MATCHED_DATE_RANGE,
                    enqueueSnackbar,
                    'error',
                );
            }
        }

        setErrors({ ...tempErrors });
        return tempErrors;
    };

    const handleDateChange = (date, name) => {
        setInitialData((prevData) => ({
            ...prevData,
            [name]: date,
        }));
    };

    const handleButtonClick = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setScheduledTime(null);
    };

    const handleSaveNow = async () => {
        setOpenDialog(false);
        await executeSubmit();
    };

    const handleScheduleSave = async () => {
        if (!scheduledTime) {
            showMessage('Цаг сонгоно уу', enqueueSnackbar, 'error');
            return;
        }
        setOpenDialog(false);

        const formattedStartDate = format(
            new Date(initialData.startDate),
            'yyyy/MM/dd',
        );
        const formattedEndDate = format(
            new Date(initialData.endDate),
            'yyyy/MM/dd',
        );
        const formattedScheduledTime = format(
            new Date(scheduledTime),
            'yyyy/MM/dd HH:mm',
        );
        const query = new URLSearchParams({
            startDate: formattedStartDate,
            endDate: formattedEndDate,
            scheduleTime: formattedScheduledTime,
        }).toString();

        const apiUrl = `${process.env.REACT_APP_CMS_API_PATH}/schedule/epg?${query}`;

        try {
            const response = await axios.post(
                apiUrl,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    timeout: 30000,
                },
            );

            showMessage(
                `${response.data.data} || ${SUCCESS_MESSAGES.ADDED_DATA}`,
                enqueueSnackbar,
            );
            history.push(ROUTES_LIST.execute);
            showMessage(
                `Хадгалах цаг: ${format(new Date(scheduledTime), 'yyyy/MM/dd HH:mm')}`,
                enqueueSnackbar,
                'success',
            );
        } catch (error) {
            const errorMessage = error.response?.data?.message
                ? error.response.data.message
                : ERROR_MESSAGES.REQUEST_FAIL;
            showMessage(errorMessage, enqueueSnackbar, 'error');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        handleButtonClick();
    };

    const executeSubmit = async () => {
        const formattedStartDate = format(
            new Date(initialData.startDate),
            'yyyy/MM/dd',
        );
        const formattedEndDate = format(
            new Date(initialData.endDate),
            'yyyy/MM/dd',
        );
        const query = new URLSearchParams({
            startDate: formattedStartDate,
            endDate: formattedEndDate,
        }).toString();

        const apiUrl = `${process.env.REACT_APP_CMS_API_PATH}/execute/epg?${query}`;

        try {
            await axios.get(apiUrl, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                timeout: 30000,
            });

            showMessage(SUCCESS_MESSAGES.ADDED_DATA, enqueueSnackbar);
            history.push(ROUTES_LIST.execute);
        } catch (error) {
            const errorMessage = error.response?.data?.message
                ? error.response.data.message
                : ERROR_MESSAGES.REQUEST_FAIL;
            showMessage(errorMessage, enqueueSnackbar, 'error');
        }
    };

    return (
        <>
            <div>
                <PageHeader
                    pageName={`Долоо хоногийн хөтөлбөрүүдийг нэгтгэж хадгалах`}
                    showAddNew={false}
                />
            </div>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '25px',
                }}
            >
                <div style={{ marginLeft: '10px' }}>
                    <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        locale={locale}
                    >
                        <DesktopDatePicker
                            label="Эхлэх өдөр"
                            inputFormat="yyyy/MM/dd"
                            mask="____/__/__"
                            value={initialData.startDate}
                            disabled={datepickerIsDisabled}
                            onChange={(newValue) => {
                                handleDateChange(newValue, 'startDate');
                            }}
                            renderInput={(params) => <TextField {...params} />}
                        />
                        <RemoveIcon style={{ padding: '15px 5px' }} />
                        <DesktopDatePicker
                            label="Дуусах өдөр"
                            inputFormat="yyyy/MM/dd"
                            mask="____/__/__"
                            value={initialData.endDate}
                            disabled={datepickerIsDisabled}
                            onChange={(newValue) => {
                                handleDateChange(newValue, 'endDate');
                            }}
                            renderInput={(params) => <TextField {...params} />}
                        />
                    </LocalizationProvider>
                </div>

                {showSaveButton && (
                    <Button
                        color="success"
                        style={{
                            marginLeft: '10px',
                            width: '150px',
                            height: '50px',
                        }}
                        type="submit"
                        variant="outlined"
                        onClick={handleSubmit}
                    >
                        <Typography style={{ marginLeft: '10px' }}>
                            Хадгалах
                        </Typography>
                    </Button>
                )}
            </div>

            <Dialog open={openDialog} onClose={handleCloseDialog}>
                <DialogTitle style={{ textAlign: 'center' }}>
                    Хадгалах сонголт
                </DialogTitle>
                <DialogContent>
                    <div
                        style={{
                            display: 'flex',
                            gap: '20px',
                            minWidth: '400px',
                            paddingTop: '10px',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                borderRight: '1px solid #ccc',
                                paddingRight: '20px',
                            }}
                        >
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleSaveNow}
                                fullWidth
                            >
                                Одоо хадгалах
                            </Button>
                        </div>

                        <div>
                            <div style={{ marginBottom: '10px' }}>
                                <Typography
                                    variant="body2"
                                    style={{ marginBottom: '10px' }}
                                >
                                    Хадгалах цаг тохируулах:
                                </Typography>
                                <LocalizationProvider
                                    dateAdapter={AdapterDateFns}
                                    locale={locale}
                                >
                                    <DateTimePicker
                                        label="Огноо ба цаг"
                                        inputFormat="yyyy/MM/dd HH:mm"
                                        value={scheduledTime}
                                        onChange={(newValue) => {
                                            setScheduledTime(newValue);
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} fullWidth />
                                        )}
                                        minDateTime={new Date()}
                                    />
                                </LocalizationProvider>
                            </div>

                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={handleScheduleSave}
                                disabled={!scheduledTime}
                                fullWidth
                            >
                                Цаг тохируулж хадгалах
                            </Button>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog}>Хаах</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
